// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__9cQKA","rows":"Monitor_rows__yoS2A","boxes":"Monitor_boxes__wMw3A","attitude":"Monitor_attitude__AWeDd"};